export function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

const JS_KEYWORDS = 'const|let|await|async|fetch|import|from|new|console|log|FormData|JSON|stringify'
const PY_KEYWORDS = 'import|print|requests|open|json|True|False|None'

export function highlightCode(src, lang) {
  const escaped = escapeHtml(src)

  if (lang === 'json' || src.trim().startsWith('{')) {
    return escaped.replace(
      /(&quot;[^&]*&quot;)(\s*:)?|\b(-?\d+(?:\.\d+)?)\b|\b(true|false|null)\b|(\/\/[^\n]*)/g,
      (m, str, colon, num, kw, comment) => {
        if (comment) return `<span class="tok-comment">${comment}</span>`
        if (colon) return `<span class="tok-key">${str}</span>${colon}`
        if (str) return `<span class="tok-str">${str}</span>`
        if (num) return `<span class="tok-num">${num}</span>`
        if (kw) return `<span class="tok-bool">${kw}</span>`
        return m
      },
    )
  }

  let out = escaped
    .replace(/(&quot;[^&]*&quot;|&#39;[^&]*&#39;)/g, '<span class="tok-str">$1</span>')
    .replace(/(\/\/[^\n]*)/g, '<span class="tok-comment">$1</span>')

  const keywords = lang === 'python' ? PY_KEYWORDS : JS_KEYWORDS
  out = out.replace(new RegExp(`\\b(${keywords}|curl)\\b`, 'g'), '<span class="tok-kw">$1</span>')
  out = out.replace(/--[a-zA-Z-]+/g, '<span class="tok-flag">$&</span>')
  out = out.replace(/\b(\d+)\b/g, '<span class="tok-num">$1</span>')

  return out
}
